import {
  Box,
  ButtonGroup,
  HStack
} from "@chakra-ui/react";
import { DateTime } from "luxon";
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/Common/CustomButton";
import ReactDatePicker2 from "../../../components/Common/CustomDatePicker/ReactDatePicker2";

interface Props {
  startDate: DateTime | null;
  endDate: DateTime | null;
  handleStartDate: (date: DateTime | null) => void;
  handleEndDate: (date: DateTime | null) => void;
  onSearch: () => void;
  onClear: () => void;
  isLoading?: boolean;

}

const DateRangeInputs: React.FC<Props> = ({
  startDate,
  endDate,
  onSearch,
  onClear,
  isLoading = false,
  handleEndDate,
  handleStartDate,

}) => {
  const { t } = useTranslation();

  //   const handleStartDate = (date: DateTime | null, name: string) => {
  //     if (date) {
  //       console.log(date.toFormat("yyyy-MM-dd"), "datedate");
  //     }
  //   };

  return (
    <HStack spacing={4} align="flex-end" wrap="wrap" alignItems="center">
      <Box display="flex" alignItems="center" gap={2}>
        <ReactDatePicker2
          name="startDate"
          value={startDate}
          onChange={handleStartDate}
          placeholderText={t("order.list.selectStartDate")}

          
        />
        <ReactDatePicker2
          name="endDate"
          value={endDate}
          onChange={handleEndDate}
          placeholderText={t("order.list.selectEndDate")}
        />
      </Box>
      <ButtonGroup justifyContent={"flex-end"}>
        <CustomButton
          handleClick={onSearch}
          title={t("common.button.search")}
          loading={isLoading}
          disabled={!endDate}
          sx={{ marginLeft: "20px", marginBottom: 0 }}
        />
        <CustomButton
          handleClick={onClear}
          title={t("order.list.clear")}
          loading={false}
          variant="light"
          sx={{ marginRight: "20px", marginBottom: 0 }}
        />
      </ButtonGroup>
    </HStack>
  );
};

export default DateRangeInputs;
